"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const services = [{
  id: "roof-electrical",
  title: "Roof & Electrical",
  subtitle: "Structural & Power",
  description: "Critical evaluation of your home's protective shell and the electrical infrastructure powering your daily life.",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/roof_electrical_inspection.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/roof_electrical_inspection.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/roof_electrical_inspection.png-wvc-sizes",
  imgAlt: "Roof and electrical panel inspection",
  buttonText: "View Inspection Details",
  buttonLink: "/FourPointInspectionSouthFloridaPage"
}, {
  id: "plumbing-hvac",
  title: "Plumbing & HVAC",
  subtitle: "Flow & Climate",
  description: "Detailed assessment of water systems and climate control units to ensure efficiency and prevent costly leaks.",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/plumbing_hvac_check.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/plumbing_hvac_check.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/plumbing_hvac_check.png-wvc-sizes",
  imgAlt: "Plumbing and HVAC system review",
  buttonText: "Check System Health",
  buttonLink: "/FourPointInspectionSouthFloridaPage"
}, {
  id: "safety-compliance",
  title: "Safety & Compliance",
  subtitle: "Insurance Ready",
  description: "Verification of all major systems against Florida safety standards to secure your home insurance coverage.",
  imgSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/safety_compliance_audit.png",
  imgSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/safety_compliance_audit.png-wvc-srcset",
  imgSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/safety_compliance_audit.png-wvc-sizes",
  imgAlt: "Safety compliance and insurance inspection",
  buttonText: "Check System Health",
  buttonLink: "/FourPointInspectionSouthFloridaPage"
}];
const benefits = [{
  serviceId: "roof-electrical",
  text: "Roof age, material & condition"
}, {
  serviceId: "roof-electrical",
  text: "Electrical panel & wiring safety"
}, {
  serviceId: "roof-electrical",
  text: "Hazardous component detection"
}, {
  serviceId: "plumbing-hvac",
  text: "Pipe materials & corrosion check"
}, {
  serviceId: "plumbing-hvac",
  text: "HVAC age & operational status"
}, {
  serviceId: "plumbing-hvac",
  text: "Water heater safety & leaks"
}, {
  serviceId: "safety-compliance",
  text: "commonly requested by insurance carriers"
}, {
  serviceId: "safety-compliance",
  text: "Mitigation of future risks"
}, {
  serviceId: "safety-compliance",
  text: "Peace of mind for homeowners"
}];
export default function InstallationRepairReplacementOptions() {
  return <section data-section-id="245384" id="what-systems-are-reviewed" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-12 max-w-3xl text-center md:mb-16">
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold md:text-4xl tracking-tight">
            What Systems Are Reviewed?
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Our 4-Point Inspection focuses on the four major systems that most
            insurance carriers require to determine your home's insurability.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {services.map((service, i) => <Card key={service.id} data-index={i} className="border-border bg-card flex flex-col overflow-hidden shadow-md transition-shadow hover:shadow-xl rounded-lg">
              <div className="bg-muted aspect-video w-full overflow-hidden">
                <img src={service.imgSrc} data-wvc-srcset={service.imgSrcset} data-wvc-sizes={service.imgSizes} alt={service.imgAlt} className="h-full w-full object-cover" loading="lazy" />
              </div>
              <CardHeader>
                <div className="mb-2 flex items-center justify-between">
                  <Badge variant="secondary" className="font-default bg-secondary text-secondary-foreground">
                    {service.subtitle}
                  </Badge>
                </div>
                <CardTitle className="font-default text-2xl text-foreground">
                  {service.title}
                </CardTitle>
                <CardDescription className="mt-2 text-base text-muted-foreground font-default">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="flex-grow">
                <ul className="space-y-3">
                  {benefits.filter(b => b.serviceId === service.id).map((benefit, j) => <li key={j} data-index={j} className="text-muted-foreground flex items-start gap-3 font-default">
                        <CircleCheck className="text-primary mt-0.5 h-5 w-5 shrink-0" />
                        <span>{benefit.text}</span>
                      </li>)}
                </ul>
              </CardContent>
              <CardFooter className="border-border/50 border-t pt-6">
                <Button asChild className="w-full bg-primary text-primary-foreground hover:opacity-90 transition-opacity font-default">
                  <Link to={service.buttonLink}>{service.buttonText}</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}